import React from 'react';
import { Button } from './Button';
import { FadeIn } from './FadeIn';
import { Clock } from 'lucide-react';
export function Urgency() {
  const goToCheckout = () => {
    window.open('https://43skvt-1y.myshopify.com/products/como-vender-en-amazon-fba-desde-cero-2026-bonos-exclusivos', '_blank');
  };
  return <section className="bg-brand-green py-20 px-6 text-white text-center" data-id="element-270">
      <div className="max-w-3xl mx-auto" data-id="element-271">
        <FadeIn data-id="element-272">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-white/10 rounded-full mb-8" data-id="element-273">
            <Clock className="w-8 h-8 text-brand-gold" data-id="element-274" />
          </div>

          <h2 className="text-3xl md:text-4xl font-bold mb-8" data-id="element-275">
            Este precio es de lanzamiento.
          </h2>

          <div className="bg-white/5 border border-brand-gold/30 rounded-xl p-6 inline-block mb-10" data-id="element-276">
            <p className="text-xl text-brand-gold font-medium flex items-center gap-3" data-id="element-277">
              <span data-id="element-278">👉</span> Puede aumentar en cualquier momento sin previo
              aviso
            </p>
          </div>

          <div data-id="element-279">
            <Button onClick={goToCheckout} className="bg-brand-gold hover:bg-brand-gold/90 text-brand-green shadow-brand-gold/20 text-lg px-10" data-id="element-280">
              QUIERO ACCEDER AHORA
            </Button>
          </div>
        </FadeIn>
      </div>
    </section>;
}